export function handleName(name: string): string{
    switch (name){
        case "Netherlands":
            return "Neth";
        case "Switzerland":
            return "Switz";
        default:
            return name;
    }
}